// src/context/FormContext.jsx
import { createContext, useContext, useEffect, useReducer, useCallback, useMemo } from 'react';
import { REGISTROS_INICIAL } from '../utils/initialStates';
import { TRAMITACIONES_INTERNAS_INICIAL } from '../utils/initialStates';
import { TRAMITACIONES_EXTERNAS_INICIAL } from '../utils/initialStates';
import { SELECTED_REQUISITOS_INICIAL } from '../utils/initialStates';
import { PAGO_PROYECTOS_INICIAL } from "../utils/initialStates";
import { PAGO_MEJORAS_INICIAL } from "../utils/initialStates";
import { PAGO_MICROCREDITOS_INICIAL } from "../utils/initialStates";

const FormContext = createContext();

// Estado inicial
const initialState = {
	formA: {
		// Agrega aquí los campos iniciales del formulario A
		datosGenerales: { ...REGISTROS_INICIAL },
		// ...otros campos
		tipoSubtipoProyecto: [{ tipo: '', subtipo: '', cantidad: '', unidad: '' }],
		array_obras_expediente: [{
            expediente_o: "",
            objeto_o: "",
            fecha_caratulacion_o: null,
            descripcion_objeto_o: ""
        }]
	},
	formB: {	
		// Sección de requisitos
		selectedRequisitos: { ...SELECTED_REQUISITOS_INICIAL },
		
		
		tramitacion: { ...TRAMITACIONES_INTERNAS_INICIAL },
		// Sección de tramitaciones externas
		tramitacionesExternas: [...TRAMITACIONES_EXTERNAS_INICIAL],
		
		// Fechas de tramitación externa ----> ahora viene todo en tramitacionesExternas
		//fechaSalidaConvenio: null,
		//fechaFirmaConvenio: null,
		//fechaSalidaResolucion: null,
		//fechaFirmaResolucion: null,
		
		// Observaciones
		//observacionesReporteEntidad: '',
		//observacionesInternas: '',
		//observacionesTramitacionExterna: { ...TRAMITACIONES_EXTERNAS_INICIAL },
		
		// Campos para mantener compatibilidad (se pueden eliminar una vez migrado todo)
		
		observaciones: {
			reporteEntidad: '',
			internas: '',
			tramitacionExterna: ''
		}
	},
	formC: {
		// Campos del formulario C
		seguimientoObra: {
			encargadoRendicion: '',
			montoObra: '',
			organismoEncargado: '',
			empresaContratista: '',
			fechaInicioObra: '',
			fechaFinObra: '',			
			observaciones: ''
		},
		//vamos a sacar los arrays por fuera de seguiemientoObra
		arrayPagosMejoras: [...PAGO_MEJORAS_INICIAL],// NO OLVIDAR los ... para que se copien los valores
		arrayPagosMicrocreditos: [...PAGO_MICROCREDITOS_INICIAL],
		arrayPagosProyectos: [...PAGO_PROYECTOS_INICIAL],
	},
	// Estado para controlar qué pestaña está activa
	activeTab: 'tab1',
	// Estado para manejar la validación de formularios
	validation: {
		formA: { isValid: false, errors: {} },
		formB: { isValid: false, errors: {} },
		formC: { isValid: false, errors: {} }
	}
};

// Reducer para manejar las acciones del formulario
function formReducer(state, action) {
	console.log('TORO Reducer - Acción recibida:', action);
	console.log('TORO Reducer - Estado actual:', state);

	switch (action.type) {
		case 'UPDATE_FIELD':
			// Si la sección es 'tipoSubtipoProyecto', manejarlo de manera especial
			if (action.section === 'tipoSubtipoProyecto') {
				return {
					...state,
					[action.form]: {
						...state[action.form],
						[action.section]: action.value
					}
				};
			} else if (action.section === 'array_obras_expediente') {
                return {
                    ...state,
                    [action.form]: {
                        ...state[action.form],
                        [action.section]: action.value
                    }
                };
            } else if (action.section === 'arrayPagosMejoras') {
                return {
                    ...state,
                    [action.form]: {
                        ...state[action.form],
                        [action.section]: action.value
                    }
                };
            } else if (action.section === 'arrayPagosMicrocreditos') {
                return {
                    ...state,
                    [action.form]: {
                        ...state[action.form],
                        [action.section]: action.value
                    }
                };
            } else if (action.section === 'arrayPagosProyectos') {
                return {
                    ...state,
                    [action.form]: {
                        ...state[action.form],
                        [action.section]: action.value
                    }
                };
            }
			  // Para campos normales dentro de secciones
			return {
				...state,
				[action.form]: {
					...state[action.form],
					[action.section]: {
						...state[action.form][action.section],
						[action.field]: action.value
					}
				}
			};

		case 'UPDATE_FORM_DATA':
			console.log('TORO Reducer - Procesando UPDATE_FORM_DATA');
			console.log('TORO Reducer - form:', action.form);
			console.log('TORO Reducer - data:', action.data);
			console.log('TORO Reducer - Estado actual de formA:', state[action.form]);
			const newState = {
				...state,
				[action.form]: {
				  ...state[action.form],
				  ...action.data
				}
			  };
			  console.log('TORO Reducer - Nuevo estado:', newState);
			  return newState;

		case 'UPDATE_OBSERVACION':
			// Mantener compatibilidad con el código existente
			const updatedObservaciones = {
				...state.formB.observaciones,
				[action.observacionType]: action.value
			};
			
			// Mapear a la nueva estructura
			const observacionesMapping = {
				reporteEntidad: 'observacionesReporteEntidad',
				internas: 'observacionesInternas',
				tramitacionExterna: 'observacionesTramitacionExterna'
			};
			
			const updatedFormB = {
				...state.formB,
				observaciones: updatedObservaciones
			};
			
			// Actualizar el campo correspondiente en la nueva estructura
			if (observacionesMapping[action.observacionType]) {
				updatedFormB[observacionesMapping[action.observacionType]] = action.value;
			}
			
			return {
				...state,
				formB: updatedFormB
			};

		case 'UPDATE_TRAMITACIONES':
			// Mantener compatibilidad con el código existente
			const updatedTramitaciones = {
				...state.formB.tramitaciones,
				[action.tramitacionType]: action.value
			};
			
			// Mapear a la nueva estructura
			const tramitacionesMapping = {
				internas: 'tramitacionesInternas',
				externas: 'tramitacionesExternas'
			};
			
			const updatedFormBTramitaciones = {
				...state.formB,
				tramitaciones: updatedTramitaciones
			};
			
			// Actualizar el campo correspondiente en la nueva estructura
			if (tramitacionesMapping[action.tramitacionType]) {
				updatedFormBTramitaciones[tramitacionesMapping[action.tramitacionType]] = action.value;
			}
			
			return {
				...state,
				formB: updatedFormBTramitaciones
			};
			
		case 'UPDATE_FORM_B':
			// Actualización directa de cualquier campo en formB
			return {
				...state,
				formB: {
					...state.formB,
					...action.payload
				}
			};

		//case for UPDATE_FROM_C
		case 'UPDATE_FORM_C':
			return {
				...state,
				formC: {
					...state.formC,
					...action.payload
				}
			};

		case 'SET_ACTIVE_TAB':
			return {
				...state,
				activeTab: action.tabId
			};

		case 'VALIDATE_FORM':
			return {
				...state,
				validation: {
					...state.validation,
					[action.form]: {
						isValid: action.isValid,
						errors: action.errors || {}
					}
				}
			};

		case 'RESET_FORM':
			return initialState;

		default:
			console.warn('Reducer - Acción no manejada:', action.type);
			return state;
	}
}

export const FormProvider = ({ children }) => {
	const [state, dispatch] = useReducer(formReducer, initialState);
	console.log("STATE", state)

	// Agrega un efecto para rastrear cambios en el estado
	useEffect(() => {
		console.log('TORO FormProvider - Estado actualizado:', state);
		console.log('TORO FormProvider - formA actual:', state.formA);
		console.log('TORO FormProvider - formB actual:', state.formB);
		console.log('TORO FormProvider - formC actual:', state.formC);
	}, [state]);

	// Actualizar un campo del formulario
	const updateField = useCallback((form, section, field, value) => {
		console.log('updateField - Antes de dispatch:', { form, section, field, value });
		
		/*if (section === 'arrayPagosMejoras') {
			
			dispatch({
				type: 'UPDATE_FIELD',
				form,
				section: 'arrayPagosMejoras',
				value: Array.isArray(value) ? value : [value]
			});
		} 
		*/

		// Casos especiales para formA
		if (form === 'formA') {
			if (section === 'tipoSubtipoProyecto') {
				dispatch({
					type: 'UPDATE_FIELD',
					form,
					section: 'tipoSubtipoProyecto',
					value: Array.isArray(value) ? value : [value]
				});
			} else if (section === 'array_obras_expediente') {
				dispatch({
					type: 'UPDATE_FIELD',
					form,
					section: 'array_obras_expediente',
					value: Array.isArray(value) ? value : [value]
				});
			} else if (field && !state.formA[section]) {
				// Comportamiento normal para otros campos
				dispatch({
					type: 'UPDATE_FIELD',
					form,
					section,
					field,
					value
				});
			}
		}

		// Casos para formB
		if (form === 'formB') {
			// Si es un campo de tramitaciones internas
			if (section === 'tramitacionesInternas' && field) {
				return dispatch({
					type: 'UPDATE_FORM_B',
					payload: {
						tramitacionesInternas: {
							...state.formB.tramitacionesInternas,
							[field]: value
						}
					}
				});
			}
			// Para campos directos de formB
			else if (field && !state.formB[section]) {
				return dispatch({
					type: 'UPDATE_FORM_B',
					payload: {
						[section]: value
					}
				});
			}
		}

		//Casos para formC
		if (form === 'formC') {
			//agregar casos para arrayPagosMejoraas
			if (section === 'arrayPagosMejoras') {
				return dispatch({
					type: 'UPDATE_FIELD',
					form,
					section: 'arrayPagosMejoras',
					value: Array.isArray(value) ? value : [value]
				});
			} else if (section === 'arrayPagosMicrocreditos') {
				return dispatch({
					type: 'UPDATE_FIELD',
					form,
					section: 'arrayPagosMicrocreditos',
					value: Array.isArray(value) ? value : [value]
				});
			} else if( section ==='arrayPagosProyectos') {
				return dispatch({
					type: 'UPDATE_FIELD',
					form,
					section: 'arrayPagosProyectos',
					value: Array.isArray(value) ? value : [value]
				});
			} else if (section === 'seguimientoObra') {
				return dispatch({
					type: 'UPDATE_FIELD',
					form,
					section,
					field,
					value
				});
			}
		}

		// Comportamiento por defecto (campos anidados)
		return dispatch({
			type: 'UPDATE_FIELD',
			form,
			section,
			field,
			value
		});


	}, []);//state.formA, state.formB
	//NOTA para mi yo del futuro:  // DEJAR Sin dependencias para evitar recreaciones innecesarias

	// Actualizar datos completos de un formulario
	const updateFormData = useCallback((form, data) => {
		console.log('updateFormData - Antes de dispatch:', { form, data });
		dispatch({
			type: 'UPDATE_FORM_DATA',
			form,
			data
		});
	}, []);

	const updateFormB = useCallback((updates) => {
		dispatch({
			type: 'UPDATE_FORM_B',
			payload: updates
		});
	}, []);

	//updateFormC
	const updateFormC = useCallback((updates) => {
		dispatch({
			type: 'UPDATE_FORM_C',
			payload: updates
		});
	}, []);

	// Actualizar observaciones
	const updateObservacion = useCallback((observacionType, value) => {
		// Mapeo de tipos de observación a los nombres de campo en formB
		const fieldMap = {
			'reporteEntidad': 'observacionesReporteEntidad',
			'internas': 'observacionesInternas',
			'tramitacionExterna': 'observacionesTramitacionExterna'
		};

		const field = fieldMap[observacionType];
		if (!field) {
			console.warn(`Tipo de observación no reconocido: ${observacionType}`);
			return;
		}

		dispatch({
			type: 'UPDATE_FORM_B',
			payload: {
				// Mantener compatibilidad con la estructura antigua
				observaciones: {
					...state.formB.observaciones,
					[observacionType]: value
				}
			}
		});
	}, [state.formB.observaciones]);

	// Actualizar trámites
	const updateTramitaciones = useCallback((tipo, value) => {
		// Mapeo de tipos de trámites a los nombres de campo en formB
		const fieldMap = {
			'internas': 'tramitacionesInternas',
			'externas': 'tramitacionesExternas'
		};

		const field = fieldMap[tipo];
		if (!field) {
			console.warn(`Tipo de trámite no reconocido: ${tipo}`);
			return;
		}

		dispatch({
			type: 'UPDATE_FORM_B',
			payload: {
				[field]: value
			}
		});
	}, []);

	// Asegúrate de que updateTramitaciones esté correctamente implementado
	/*const updateTramitaciones = useCallback((tipo, value) => {
		dispatch({
			type: 'UPDATE_TRAMITACIONES',
			payload: { tipo, value }
		});
	}, []);*/

	// Para actualizar:
	const updateTramitacionInterna = useCallback((value) => {
		dispatch({
			type: 'UPDATE_FORM_B',
			payload: {
				tramitacion: value
			}
		});
	}, []);

	// Cambiar pestaña activa
	const setActiveTab = useCallback((tabId) => {
		dispatch({
			type: 'SET_ACTIVE_TAB',
			tabId
		});
	}, []);

	// Validar formulario
	const validateForm = useCallback((form, isValid, errors = {}) => {
		dispatch({
			type: 'VALIDATE_FORM',
			form,
			isValid,
			errors
		});
	}, []);

	// Resetear formulario
	const resetForm = useCallback(() => {
		dispatch({ type: 'RESET_FORM' });
	}, []);

	// Función para depuración
	const debugContext = () => {
		console.group('Debug FormContext');
		console.log('Estado completo:', state);
		console.log('formA:', state.formA);
		console.log('datosGenerales:', state.formA?.datosGenerales);
		console.log('tipoSubtipoProyecto:', state.formA?.tipoSubtipoProyecto);
		console.log('array_obras_expediente:', state.formA?.array_obras_expediente);
		console.log('arrayPagosMejoras:', state.formC?.arrayPagosMejoras);
		console.groupEnd();
	  };
	
	  // Agrega esto al value del provider
	  const contextValue = useMemo(() => ({
		...state,
		updateField,
		updateFormData,
		updateFormB,
		updateFormC,
		debugContext, // Añade la función de depuración
		updateObservacion,
		updateTramitaciones,
		updateTramitacionInterna,
		setActiveTab,
		validateForm,
		resetForm
	  }), [state, updateField, updateFormData, updateFormB, updateFormC, updateObservacion, updateTramitaciones, updateTramitacionInterna, setActiveTab, validateForm, resetForm]);

	return (
		<FormContext.Provider
			value={contextValue}
			/*value={{
				...state, // Aquí se incluye formA, formB, formC, activeTab, validation
				updateField, // Aquí se incluye la función updateField
				updateFormData,
				updateObservacion,
				updateTramitaciones,
				setActiveTab,
				validateForm,
				resetForm
			}}*/
		>
			{children}
			{/* Botón de depuración (puedes eliminarlo después) */}
			{/*<button
				onClick={debugContext}
				style={{
					position: 'fixed',
					bottom: '20px',
					right: '20px',
					zIndex: 9999,
					padding: '10px',
					background: '#f00',
					color: '#fff',
					border: 'none',
					borderRadius: '4px',
					cursor: 'pointer'
				}}
			>
				Debug Context
			</button>*/}
		</FormContext.Provider>
	);
};

export const useFormContext = () => {
	const context = useContext(FormContext);
	if (!context) {
		throw new Error('useFormContext debe usarse dentro de un FormProvider');
	}
	return context;
};